import { Icon } from '@chakra-ui/react';

export const GameControllerIcon = ({ color = '#333131' }: { color?: string }) => {
	return (
		<Icon
			width="30px"
			height="30px"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="9.59084"
				cy="4.09084"
				r="3.34084"
				stroke="#333131"
				strokeWidth="1.5"
			/>
			<path
				d="M5.09502 12.5972H2.56123C2.52357 12.5972 2.48902 12.6181 2.47155 12.6514L1.01156 15.4387C1.00397 15.4532 1 15.4693 1 15.4857V19.0867C1 19.1426 1.04532 19.188 1.10123 19.188H17.9894C18.0453 19.188 18.0906 19.1426 18.0906 19.0867V15.8028C18.0906 15.7871 18.087 15.7716 18.0799 15.7576L16.5277 12.6531C16.5106 12.6188 16.4755 12.5972 16.4372 12.5972H14.0753"
				stroke="#333131"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M8.01562 6.94385V12.2181"
				stroke="#333131"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.1641 6.94385V12.2181"
				stroke="#333131"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Icon>
	);
};
